import React from 'react';
import { connect } from 'react-redux';
import { Collapse } from '@mui/material';
import { WAVE_STYLE, VISUALIZER_SHAPE, HOLLOW_CENTER_WAVE_STYLES } from '../../Preview/PreviewDisplayConstants';
import CondensedListItem from '../../../../list-items/CondensedListItem';
import VisualizerShapeListItem from './inputs/VisualizerShapeListItem';
import VisualizerDirectionListItem from './inputs/VisualizerDirectionListItem';
import VisualizerWaveStyleListItem from './inputs/VisualizerWaveStyleListItem';
import VisualizerReflectionTypeListItem from './inputs/VisualizerReflectionTypeListItem';
import VisualizerLayoutTypeListItem from './inputs/VisualizerLayoutTypeListItem';
import VisualizerSmoothListItem from './inputs/VisualizerSmoothListItem';
import VisualizerInvertListItem from './inputs/VisualizerInvertListItem';
import VisualizerHollowCenterListItem from './inputs/VisualizerHollowCenterListItem';
import VisualizerPointCountListItem from './inputs/VisualizerPointCountListItem';
import VisualizerBarWidthListItem from './inputs/VisualizerBarWidthListItem';
import VisualizerPointRadiusListItem from './inputs/VisualizerPointRadiusListItem';
import VisualizerDiameterListItem from './inputs/VisualizerDiameterListItem';
import VisualizerImageSizeListItem from './inputs/VisualizerImageSizeListItem';
import VisualizerWidthListItem from './inputs/VisualizerWidthListItem';
import VisualizerBaseHeightListItem from './inputs/VisualizerBaseHeightListItem';
import VisualizerXPositionListItem from './inputs/VisualizerXPositionListItem';
import VisualizerYPositionListItem from './inputs/VisualizerYPositionListItem';
import VisualizerWaveHeightListItem from './inputs/VisualizerWaveHeightListItem';
import VisualizerSeparationListItem from './inputs/VisualizerSeparationListItem';
import VisualizerRotationListItem from './inputs/VisualizerRotationListItem';

class VisualizerShapeEditor extends React.Component {
    render() {
        const { visualizerWaveStyle, visualizerShape } = this.props;
        const shapeIsCircle = visualizerShape === VISUALIZER_SHAPE.CIRCLE;

        return (
            <>
                <VisualizerShapeListItem />

                {/* Direction only applies to the circular shape; it collapses away for flat. */}
                <Collapse in={shapeIsCircle} unmountOnExit>
                    <VisualizerDirectionListItem />
                </Collapse>

                <VisualizerWaveStyleListItem />

                {visualizerWaveStyle === WAVE_STYLE.SOLID || visualizerWaveStyle === WAVE_STYLE.LINE ?
                    <VisualizerPointCountListItem />
                : visualizerWaveStyle === WAVE_STYLE.BAR ?
                    this.renderCondensedList(<VisualizerPointCountListItem />, <VisualizerBarWidthListItem />)
                : visualizerWaveStyle === WAVE_STYLE.POINT &&
                    this.renderCondensedList(<VisualizerPointCountListItem />, <VisualizerPointRadiusListItem />)
                }

                <VisualizerReflectionTypeListItem />

                <VisualizerLayoutTypeListItem />

                <VisualizerSmoothListItem />

                <VisualizerInvertListItem />

                {/* Hollow Center starts the waves at the ring instead of the center, so it applies to the
                    circular bar and solid styles. It sits directly below Invert Spectrum in both the
                    global and the per-layer Customize panel. */}
                {shapeIsCircle && HOLLOW_CENTER_WAVE_STYLES.includes(visualizerWaveStyle) &&
                    <VisualizerHollowCenterListItem />
                }

                { shapeIsCircle ?
                    this.renderCondensedList(<VisualizerDiameterListItem />, <VisualizerImageSizeListItem />)
                :
                    this.renderCondensedList(<VisualizerWidthListItem />, <VisualizerBaseHeightListItem />)
                }
                
                { this.renderCondensedList(<VisualizerXPositionListItem />, <VisualizerYPositionListItem />) }

                { this.renderCondensedList(<VisualizerWaveHeightListItem />, <VisualizerSeparationListItem />) }

                {/* Rotation keeps its half-width column even though it is now alone on the row: Center
                    Cutout used to be its neighbour but is redundant now that Hollow Center covers the
                    same need for the Solid style. */}
                { this.renderCondensedList(<VisualizerRotationListItem />) }
            </>
        );
    }

    renderCondensedList = (firstListItem, secondListItem) => {
        return (
            <CondensedListItem
                elements={[
                    {
                        width: 6,
                        component: firstListItem
                    },
                    {
                        width: 6,
                        component: secondListItem
                    },
                ]}
            />
        );
    }
}

const mapStateToProps = (state) => {
    const { 
        waveStyle: visualizerWaveStyle,
        shape: visualizerShape,
    } = state.createPreview.present.videoSettings.visualizer;

    return {
        visualizerWaveStyle,
        visualizerShape
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerShapeEditor);